import { createFileRoute } from '@tanstack/react-router';

import { SDKMissingParamsPage } from 'component/view/Redirects/SDKMissingParamsPage';

export const Route = createFileRoute('/n/sdk-missing-params-message')({
  component: SDKMissingParamsPage,
});
